import React from 'react'
import {
    Col,
    Row,
    Form
} from 'react-bootstrap'
import { useForm } from 'react-hook-form'

import {
    faSearch,
    faTimes,
    faSave,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const Address = (props) => {

    const { formState: { errors }, handleSubmit, register, trigger, watch } = useForm({ mode: 'onChange' })

    const onSubmit = data => console.log(data)

    const searchZipcode = () => {
        if (watch('zipcode') === '') {
            trigger('zipcode')
            return false
        }

        alert('ok!')
    }


    function CPFMask(v) {
        v = v.replace(/\D/g, '')
        v = v.replace(/^(\d{3})(\d)/g, '$1.$2')
        v = v.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        v = v.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
        v = v.replace(/^(\d{3})\.(\d{3})\.(\d{3})\/(\d{2})(\d)/, '$1.$2.$3-$4')
        return v.substring(0, 14)
    }


    return (

        <>

            <Form onSubmit={handleSubmit(onSubmit)}>

                <Row className='mb-3'>
                    <Col lg={5}>
                        <Form.Label htmlFor='zipcode'>CEP</Form.Label>
                        <Form.Group className='input-group'>
                            <Form.Control
                                type='text'
                                className='flex-grow-1'
                                mask={CPFMask}
                                placeholder='Informe o CEP'
                                {...register('zipcode', { required: true })}

                                register={register({
                                    required: {
                                        value: true,
                                        message: 'CPF é obrigatório',
                                    },
                                    pattern: {
                                        value: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/i,
                                        message: 'CPF inválido',
                                    },
                                })}

                            ></Form.Control>
                            <button
                                className='btn btn-primary'
                                onClick={(e) => searchZipcode()}
                                type='button'
                            >
                                <FontAwesomeIcon icon={faSearch} className='me-2' />
                                Não sei o CEP
                            </button>
                        </Form.Group>
                        {errors.zipcode && <p className='mt-1 form-error'>Campo obrigatório</p>}
                    </Col>

                    <Col lg={7} style={{ paddingTop: '34px' }}>
                        <Form.Check
                            type='switch'
                            className='float-end'
                            id='set_pattern'
                            label='Definir como padrão'
                            name='set_pattern'
                            value={1}
                        />
                    </Col>
                </Row>

                <Row className='mb-3'>
                    <Col lg={9}>
                        <Form.Group>
                            <Form.Label htmlFor='address'>Logradouro</Form.Label>
                            <Form.Control type='text' id='address' name='address' placeholder='Informe o endereço' />
                        </Form.Group>
                    </Col>

                    <Col lg={3}>
                        <Form.Group>
                            <Form.Label htmlFor='number'>Número</Form.Label>
                            <Form.Control type='text' id='number' name='number' placeholder='Informe o número' />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className='mb-3'>
                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label htmlFor='complement'>Complemento</Form.Label>
                            <Form.Control type='text' id='complement' name='complement' placeholder='Informe o complemento' />
                        </Form.Group>
                    </Col>

                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label htmlFor='neighborhood'>Bairro</Form.Label>
                            <Form.Control type='text' id='neighborhood' name='neighborhood' placeholder='Informe o bairro' />
                        </Form.Group>
                    </Col>

                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label htmlFor='city'>Cidade</Form.Label>
                            <Form.Select type='text' id='city' name='city' aria-label='Selcione a cidade'>
                                <option>Selecione</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className='mb-3'>
                    <Col lg={3}>
                        <Form.Group>
                            <Form.Label htmlFor='state'>Estado</Form.Label>
                            <Form.Select type='text' id='state' name='state' aria-label='Selecione o estado'>
                                <option>Selecione</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col lg={6}>
                        <Form.Group>
                            <Form.Label htmlFor='reference'>Referência</Form.Label>
                            <Form.Control type='text' id='reference' name='reference' placeholder='Informe a referência' />
                        </Form.Group>
                    </Col>

                    <Col lg={3}>
                        <Form.Group>
                            <Form.Label htmlFor='type_address'>Tipo de Endereço</Form.Label>
                            <Form.Select type='text' id='type_address' name='type_address' aria-label='Tipo de endereço'>
                                <option>Selecione</option>
                                <option>Cobrança</option>
                                <option>Entrega</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <hr />

                <Row className='mb-3'>
                    <Col lg={6}>
                        <button
                            className='btn btn-danger float-start'
                            onClick={(e) => props.callbackParentModal((prevState) => ({ ...prevState, show: false }))}
                            type='button'
                        >
                            <FontAwesomeIcon icon={faTimes} className='me-2' /> Cancelar
                        </button>
                    </Col>

                    <Col lg={6}>
                        <button
                            className='btn btn-primary float-end'
                            type='submit'
                        >
                            <FontAwesomeIcon icon={faSave} className='me-2' /> Gravar
                        </button>
                    </Col>
                </Row>

            </Form >

        </>

    )
}

export default Address;




